import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";

import { toLogin } from "../../services/api";

export default function Login() {
  const token = sessionStorage.getItem("token");

  const [Formdata, setFormdata] = useState({ ID: "", password: "" });
  const handleLogin = async () => {
    const res = await toLogin(Formdata);
    if (res.status === 200) {
      sessionStorage.setItem("token", res.data.token);
      message.success("Login Success");
      window.location.replace("/");
    } else {
      message.error(res.data);
    }
  };

  if (token) {
    window.location.replace("/");
  }

  return (
    <div
      className="login w-full min-h-screen bg-no-repeat bg-center grid place-content-center"
      style={{
        backgroundImage: `url('/images/login-bg.png')`,
        backgroundSize: "70%",
      }}
    >
      <h1 className="text-5xl font-bold">
        <span className="block"> Welcome back</span>
        <span className="block">
          to <span className=" text-primary">GAINS Online</span>
        </span>
      </h1>
      <h5 className="font-light">Sign in to your account below.</h5>
      <Form onFinish={handleLogin}>
        <Form.Item>
          <Input
            value={Formdata.ID}
            className="rounded-lg py-3 border-none"
            allowClear
            onChange={(e) => setFormdata({ ...Formdata, ID: e.target.value })}
            placeholder="User ID"
          />
        </Form.Item>
        <Form.Item>
          <Input.Password
            value={Formdata.password}
            className="rounded-lg py-3 border-none"
            allowClear
            onChange={(e) =>
              setFormdata({ ...Formdata, password: e.target.value })
            }
            placeholder="Password"
          />
        </Form.Item>
        <Button
          className="bg-primary text-white rounded-lg w-full h-12"
          htmlType="submit"
        >
          Sign in
        </Button>
      </Form>
    </div>
  );
}
